import indicators from "./energy-indicators.json";

export const ENERGY_CORE_REQUIRED_INDICATOR_IDS = [1, 8, 13, 15, 19];
export default indicators;
